<template>
  <div>
    <div v-if="!NavSolid" :class="NavSolid ? ' ' : 'menu-area-body'" style="height: 5rem"></div>

    <div class="bg-light py-4">
      <div class="container-lg">
        <div class="row">
          <div class="col-3 py-3 px-3 d-none d-lg-block bg-white rounded shadow-sm sticky-div mt-0" style="height: 95vh; top: 1rem">
            <div class="mb-3">
              <input type="text" class="form-control mx-0" :placeholder="$t('common.search')" />
            </div>
            <RecentlyAdded v-if="blogs.length" :recentlyAdded="blogsMostrados" />
          </div>
          <div class="col-lg-9 pl-3">
            <div class="bg-white border rounded shadow-sm p-4">
              <ImgSingleBlog :action="toggleFavorito" :blogData="infoBlog"></ImgSingleBlog>
              <menuActions :action="toggleFavorito" :buttons="buttons" @button-click="handleButtonClick" :blogData="infoBlog"></menuActions>
              <div v-if="showDiv" class="content-box"></div>
              <div ref="scrollTarget" class="mt-3">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import commentsItem from "../components/commentsItem.vue";
import Tags from "../components/Tags.vue";
import RecentlyAdded from "../components/RecentlyAdded.vue";
import Categories from "../components/Categories.vue";
import menuActions from "../components/menuActions.vue";
import ImgSingleBlog from "../components/ImgSingleBlog.vue";
import "moment/dist/locale/es";
import { resolveStoredPublicDomain } from "@/utils/publicDomainStorage";
import { applySeo, markPrerenderPending, markPrerenderReady } from "@/utils/seo";
import { tField, tFieldOrValue } from "@/i18n";

export default {
  components: { commentsItem, Tags, RecentlyAdded, Categories, menuActions, ImgSingleBlog },
  props: ["NavSolid"],
  data() {
    return {
      Tags: [],
      // Item crudo del blog (sin normalizar tittle/detail). La
      // proyeccion reactiva al locale se hace via computed.
      blogItem: null,
      infoRecentlyAdded: [
        // { id: 1, img: "https://sheltos-vue.vercel.app/image/property/4.jpg", titulo: "Departamento", precio: "1500" },
        // { id: 2, img: "https://sheltos-vue.vercel.app/image/property/4.jpg", titulo: "Villa", precio: "1500" },
        // { id: 3, img: "https://sheltos-vue.vercel.app/image/property/4.jpg", titulo: "Casa familiar", precio: "1500" },
      ],
      categoriesInfo: [
        // { id: 1, text: "Departamento", cantidad: "1" },
        // { id: 2, text: "Villa", cantidad: "15" },
        // { id: 3, text: "Casa familiar", cantidad: "15" },
        // { id: 4, text: "Casa de pueblo", cantidad: "15" },
        // { id: 5, text: "Oficinas", cantidad: "15" },
      ],
      showDiv: false,
      buttons: [
        // { label: "15 de septiempre 2025", action: "none" },
        // //{ label: "Agente", action: "none" },
        // { label: "Me gusta", action: "action" },
        // { label: "Comentarios", action: "scroll" },
      ],
      // FIX: el `infoBlog` viejo en data() (con todos los campos comentados)
      // shadowing el computed `infoBlog` del mismo nombre, asi que
      // el template siempre leia el objeto vacio del data en vez del
      // computed. Removido. El computed resuelve tittle/detail segun
      // el locale activo.
      table: "blog",
      articulos: [],
      destacados: [],
      blogs: [],
      categorias: [],
    };
  },

  computed: {
    // Locale reactivo
    currentLocale() {
      return this.$i18n.locale;
    },
    // Informacion del blog ya proyectada al idioma activo.
    // Los hijos (`ImgSingleBlog`, `menuActions`) consumen `infoBlog`
    // con `tittle`/`detail` ya resueltos, sin necesidad de conocer
    // el helper tField.
    infoBlog() {
      const it = this.blogItem;
      if (!it) return {};
      return {
        id: it.Id,
        like: "0",
        comments: "0",
        tittle: tFieldOrValue(it, "Titulo", this.currentLocale),
        date: it.Fecha,
        detail: tFieldOrValue(it, "Descripcion", this.currentLocale),
        img: it.ImgUrl || it.Imagen,
      };
    },
    // Lista de blogs crudos -> proyectada al locale (para `RecentlyAdded`).
    blogsMostrados() {
      const locale = this.currentLocale;
      return (this.blogs || []).map((it) => ({
        ...it,
        Titulo: tField(it, "Titulo", locale),
      }));
    },
    // Tags derivados de `Tipo_de_Propiedad` -> proyectados al locale
    // (los componentes `Tags` y `Categories` consumen `text`).
    tagsMostrados() {
      const locale = this.currentLocale;
      return (this.Tags || []).map((x) => ({
        id: x.Id,
        text: tField(x, "Nombre", locale),
      }));
    },
    // Categorias con `text` resuelto al locale
    categoriasMostradas() {
      const locale = this.currentLocale;
      return (this.categorias || []).map((c) => ({
        ...c,
        text: tField({ Nombre_Esp: c.text }, "Nombre", locale) || c.text,
      }));
    },
  },
  async mounted() {
    this.id = this.$route.params.id;
    markPrerenderPending();
    try {
      await this.getTags();
      await this.getBlogs();
    } finally {
      markPrerenderReady();
    }
  },
  watch: {
    "$route.params.id": {
      async handler(newId) {
        if (newId && this.blogs.length > 0) {
          this.id = newId;
          await this.loadBlogData();
          this.$forceUpdate();
        }
      },
      immediate: false,
    },
  },
  methods: {
    resolvePublicDomain() {
      return resolveStoredPublicDomain(this.$domain);
    },
    async loadBlogData() {
      markPrerenderPending();
      let infoBlog = [...this.blogs];
      infoBlog = infoBlog.filter((x) => x.Id == this.id)[0];
      if (infoBlog) {
        applySeo(infoBlog.seo);
        // Guardamos el item crudo; el computed `infoBlog` resuelve
        // tittle/detail segun el locale activo.
        this.blogItem = infoBlog;

        this.buttons = [
          { label: this.$moment(infoBlog.Fecha).utc().format("DD-MM-YYYY"), action: "none" },
          { label: this.$t('blog.like'), action: "action" },
          { label: this.$t('blog.comments'), action: "scroll" },
        ];
      } else {
        markPrerenderReady();
      }
    },
    handleButtonClick(action) {
      if (action === "action") {
        if (this.toggleFavorito === false) {
          this.toggleFavorito = true;
        } else {
          this.toggleFavorito = false;
        }
      } else if (action === "scroll") {
        this.$nextTick(() => {
          const element = this.$refs.scrollTarget;
          if (element) {
            element.scrollIntoView({ behavior: "smooth" });
          }
        });
      }
    },
    async getBlogs() {
      markPrerenderPending();
      try {
        const resolvedDomain = this.resolvePublicDomain();
        const blogDetail = await this.$store.dispatch("get", {
          path: `Blog/public/get/${this.id}?domain=${encodeURIComponent(resolvedDomain)}`,
        });
        if (blogDetail && blogDetail.Id) {
          applySeo(blogDetail.seo);
          // Guardamos el item crudo del backend; el computed `infoBlog`
          // resuelve tittle/detail segun el locale activo.
          this.blogItem = blogDetail;
          this.buttons = [
            { label: this.$moment(blogDetail.Fecha).utc().format("DD-MM-YYYY"), action: "none" },
            { label: this.$t('blog.like'), action: "action" },
            { label: this.$t('blog.comments'), action: "scroll" },
          ];
        }

        let res = await this.$store.dispatch("get", {
          path: `Blog/public/getAll?domain=${encodeURIComponent(resolvedDomain)}`,
        });
        res = Array.isArray(res) ? res : [];
        this.blogs = res;
        let infoBlog = [...res];
        infoBlog = infoBlog.filter((x) => x.Id == this.id)[0];
        if (infoBlog && !this.blogItem) {
          applySeo(infoBlog.seo);
          this.blogItem = infoBlog;
        }

        console.log("info", this.infoBlog);
        this.$moment.locale("es"); // Asegurar que el idioma esté en español

        if (this.infoBlog?.date) {
          this.buttons = [
            { label: this.$moment(this.infoBlog.date).utc().format("DD-MM-YYYY"), action: "none" },
            //{ label: "Agente", action: "none" },
            { label: this.$t('blog.like'), action: "action" },
            { label: this.$t('blog.comments'), action: "scroll" },
          ];
        }

        this.categorias = [];
        let tags = [...this.Tags];
        for await (let r of tags) {
          let cat = res.filter((x) => x.Categoria_Id == r.id);
          let categoria = {
            id: r.id,
            cantidad: cat.length.toString(),
            blogs: cat,
            text: r.text,
          };
          this.categorias.push(categoria);
        }
        if (!this.infoBlog?.tittle) {
          markPrerenderReady();
        }
      } catch (error) {
        console.log("cat", error);
        this.blogs = [];
        markPrerenderReady();
      }
    },
    async getTags() {
      try {
        const resolvedDomain = this.resolvePublicDomain();
        let res = await this.$store.dispatch("get", {
          path: `Tipo_de_Propiedad/public/getAll?domain=${encodeURIComponent(resolvedDomain)}`,
        });
        if (res.length > 0) {
          // Guardamos el item crudo de Tipo_de_Propiedad; el componente
          // `Tags` consume `text` que se resuelve via computed abajo.
          this.Tags = res;
        } else {
          this.Tags = [];
        }
      } catch (error) {
        this.Tags = [];
      }
    },
  },
};
</script>
<style scoped>
::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-track {
  background: #fdfcfc;
}

::-webkit-scrollbar-thumb {
  background: #e9e9e9;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background: #e9e9e9;
}

.content-box {
  margin-top: 20px;
  padding: 20px;
  background: #f0f0f0;
  border: 1px solid #ccc;
}

.scroll-target {
  margin-top: 50vh;
  padding: 20px;
  background: #d4edda;
  border: 1px solid #28a745;
}

.bg-img-hotel {
  background-image: url("../assets/NAO/2-home/blog4.png");
  background-color: #cccccc;
  height: 450px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
}

.inner {
  max-width: 100%;
  margin: auto;
  padding-left: 15px;
  padding-right: 15px;
}

.scroll-container {
  position: relative;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  width: 100%;
  scroll-snap-type: mandatory;
  scroll-behavior: smooth;
  word-wrap: break-word !important;
  margin-bottom: 50px;
}

.scroll-container .scroll-section {
  display: inline-block;
  vertical-align: middle;
}

.scroll-container.diff-size {
  scroll-snap-destination: 50% 0%;
  padding: 20px 0px;
  margin: 1%;
}

.scroll-container.diff-size .scroll-section {
  width: auto;
  height: 100%;
  margin-right: 15px;
  scroll-snap-coordinate: 50% 0%;
}

.scroll-container.diff-size .scroll-section:first-child {
  scroll-snap-coordinate: 0% 0%, 50% 0%;
  margin-left: 15px;
}

.scroll-container.diff-size .scroll-section:last-child {
  scroll-snap-coordinate: 50% 0%, 100% 0%;
}

.buttonsearch {
  background-color: #fd306e !important;
  color: white;
}

.inputSearch {
  border-color: #fd306e !important;
}

@media only screen and (max-width: 600px) {
}
</style>
